import { ApiStoryResponse, ApiTransitionStoryGroupResponse } from '../../../../../api/core/models';
import { conditionallyPrefixImagesWithFilesUrl } from '../../../../../functions/utilities/img-url-utility';
import { ClientNode } from '../../../../../model/client-model/client-node';
import { NodeType } from '../../../../../model/client-model/properties/node-type';
import { storyHistoricalToHistoricalEmissionsData } from './story-historical-to-historical-emissions-data';

export const transitionStoryGroupToClientNode = (
  group: ApiTransitionStoryGroupResponse,
  boardId: string,
  baseUrlFiles?: string
): ClientNode => {
  const nodeStory: ApiStoryResponse = group?.story ?? { id: group.id, title: '' };
  const historicalEmissionData = storyHistoricalToHistoricalEmissionsData(nodeStory?.historicalEmissions ?? {});
  const prefixIfSet = (url: string | undefined): string => {
    if (!url) {
      return '';
    }
    if (!baseUrlFiles) {
      return url;
    }
    return conditionallyPrefixImagesWithFilesUrl(url, baseUrlFiles);
  };
  const childNodes: string[] =
    group.subTransitionStoryGroups?.map((g) => g.id) ??
    (group.transitionElements ?? [])
      ?.map((te) => te.id)
      .concat(group.legacyCustomElements?.map((lce) => lce.id) ?? []) ??
    [];
  if (group.sortOrder) {
    childNodes.sort((a, b) => (group.sortOrder?.indexOf(a) ?? 0) - (group.sortOrder?.indexOf(b) ?? 0));
  }
  const node: ClientNode = {
    id: group.id,
    title: group.title,
    nodeProperties: {
      co2e: 0,
      data: [],
      description: '',
      diagramHeader: nodeStory?.diagramHeader ?? '',
      extendedDescription: {
        data: {
          texts: [{ body: nodeStory?.description ?? '', title: nodeStory?.title ?? '' }],
          images: [{ imgURL: prefixIfSet(nodeStory?.imgUrl), imgCredits: nodeStory?.imageCredits ?? '' }],
        },
        type: 1,
      },
      diff: 0,
      icon: '',
      imgURL: '',
      thumbnailURL: '',
      type: NodeType.Emission,
      historicalEmissionData,
      ...(group?.color ? { groupColour: group.color } : {}),
    },
    childNodes,
    actions: [],
    boardId,
    indicators: [],
    _etag: '',
    _ts: 0,
  };
  return node;
};
